type Props = {
	label: string;
	text: React.ReactNode;
};

export const LabelWithText = ({ label, text }: Props) => {
	return (
		<div className="grid grid-cols-[120px_1fr]">
			<p className="font-bold">{label}</p>

			{text}
		</div>
	);
};
